import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function ProfitSharing() {
  const [data, setData] = useState({
    partners: {},
    institutions: {},
    commissions: {},
    orders: {}
  })
  const [commissions, setCommissions] = useState([])
  const [relations, setRelations] = useState([])
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState('overview')

  useEffect(() => {
    loadOverview()
    loadCommissions()
    loadRelations()
  }, [])

  const loadOverview = () => {
    fetch(`${API}/partner-dashboard/overview`)
      .then(r => r.json())
      .then(d => { if (d.success) setData(d.data) })
      .finally(() => setLoading(false))
  }

  const loadCommissions = () => {
    fetch(`${API}/partner-dashboard/commissions`)
      .then(r => r.json())
      .then(d => { if (d.success) setCommissions(d.data || []) })
  }

  const loadRelations = () => {
    fetch(`${API}/partner-dashboard/institution-relations`)
      .then(r => r.json())
      .then(d => { if (d.success) setRelations(d.data || []) })
  }

  const formatMoney = (n) => n ? '¥' + Number(n).toLocaleString() : '¥0'

  const getLevelBadge = (level) => {
    const colors = { senior: '#fa8c16', normal: '#1890ff', '': '#999' }
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: colors[level] || '#999', color: '#fff' }}>{level === 'senior' ? '高级' : '普通'}</span>
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📊 分润管理</h2>

      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 16, marginBottom: 24 }}>
        {[
          { label: '今日佣金', value: formatMoney(data.commissions?.today), color: '#52c41a' },
          { label: '本月佣金', value: formatMoney(data.commissions?.month), color: '#1890ff' },
          { label: '累计佣金', value: formatMoney(data.commissions?.total), color: '#722ed1' },
          { label: '机构数量', value: data.institutions?.count || 0, color: '#fa8c16' },
          { label: '合伙人数量', value: data.partners?.count || 0, color: '#13c2c2' },
        ].map(s => (
          <div key={s.label} style={{ background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
            <div style={{ color: '#999', fontSize: 12 }}>{s.label}</div>
            <div style={{ fontSize: 24, color: s.color, fontWeight: 600 }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {['overview', 'commissions', 'relations'].map(t => (
          <button key={t} onClick={() => setTab(t)}
            style={{ padding: '8px 20px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, background: tab === t ? '#1890ff' : '#f0f0f0', color: tab === t ? '#fff' : '#666' }}>
            {t === 'overview' ? '总览' : t === 'commissions' ? '佣金记录' : '机构关系'}
          </button>
        ))}
      </div>

      {loading ? <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>加载中...</div> : null}

      {/* 佣金记录 */}
      {tab === 'commissions' && (
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#fafafa', borderBottom: '1px solid #f0f0f0' }}>
                {['合伙人', '类型', '订单金额', '佣金比例', '佣金金额', '订单ID', '时间'].map(h => (
                  <th key={h} style={{ padding: '12px 14px', textAlign: 'left', fontSize: 13, color: '#666', fontWeight: 500 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {commissions.length === 0 ? (
                <tr><td colSpan={7} style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无佣金记录</td></tr>
              ) : commissions.map(c => (
                <tr key={c.id} style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <td style={{ padding: '12px 14px', fontSize: 13 }}>{c.partner_name || '-'}</td>
                  <td style={{ padding: '12px 14px', fontSize: 13 }}>{getLevelBadge(c.level)}</td>
                  <td style={{ padding: '12px 14px', fontSize: 13, color: '#666' }}>{formatMoney(c.order_amount)}</td>
                  <td style={{ padding: '12px 14px', fontSize: 13 }}>{c.rate ? c.rate * 100 + '%' : '-'}</td>
                  <td style={{ padding: '12px 14px', fontSize: 13, color: '#52c41a', fontWeight: 600 }}>{formatMoney(c.commission)}</td>
                  <td style={{ padding: '12px 14px', fontSize: 12, color: '#999', fontFamily: 'monospace' }}>{c.order_id || '-'}</td>
                  <td style={{ padding: '12px 14px', fontSize: 12, color: '#999' }}>{c.created_at ? new Date(c.created_at).toLocaleDateString('zh-CN') : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* 机构关系 */}
      {tab === 'relations' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
            {relations.length === 0 ? (
              <div style={{ padding: 40, textAlign: 'center', color: '#999', gridColumn: '1/-1' }}>暂无机构关系</div>
            ) : relations.map(r => (
              <div key={r.id} style={{ padding: 16, border: '1px solid #f0f0f0', borderRadius: 8 }}>
                <div style={{ fontWeight: 500, marginBottom: 8 }}>{r.institution_name || r.name || `机构${r.institution_id}`}</div>
                <div style={{ fontSize: 12, color: '#666' }}>
                  <div>负责人：{r.owner_name || '-'}</div>
                  <div>手机：{r.owner_phone || '-'}</div>
                  <div>合伙人：{r.partner_name || '-'}</div>
                  <div>级别：{getLevelBadge(r.level)}</div>
                  <div>累计佣金：{formatMoney(r.total_commission)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
